import React, {useState} from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import PrivacyText from './PrivacyText'
import TermsText from './TermsText'
import Grid from '@material-ui/core/Grid'

export default function Privacy({open, setOpen, agree}) {
  const [openTerms, setOpenTerms] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const handleCloseTerms = () => {
    setOpenTerms(false)
  }

  return (
    <div>
      <Dialog open = {openTerms}>
        <DialogTitle>
          <IconButton
            style = {{
              position: 'absolute',
              right: 10,
              top: 10
            }}
            onClick = {handleCloseTerms}
          >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TermsText child = {true} close = {handleCloseTerms}/>
        </DialogContent>
        <DialogActions>
          <Grid container justify = 'center' direction = 'row'>
            <Grid item>
              <Button onClick = {handleCloseTerms} color = 'primary' variant = 'contained'>
                Close
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog style = {{overflow: 'hidden'}} open = {open} onClose = {handleClose}>
        <DialogTitle>
          <IconButton
            style = {{
              position: 'absolute',
              right: 10,
              top: 10
            }}
            onClick = {handleClose}
          >
            <CloseIcon/>
          </IconButton>

        </DialogTitle>
        <DialogContent>
          <PrivacyText setToggle = {setOpenTerms}/>
        </DialogContent>
        <DialogActions>
          <Grid container justify = 'center' direction = 'row'>
            <Grid item>
              <Button style = {{marginRight: 10}} onClick = {handleClose} color = 'primary' variant = 'contained'>
                Close
              </Button>
            </Grid>
            <Grid item>
              <Button onClick = {agree} color = 'primary' variant = 'contained'>
                Agree
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  )
}
